import styled from '../styled-components';

const LeftItem = styled.div`
    flex: 1 1 20rem;
`;

export default LeftItem;



// WEBPACK FOOTER //
// ./src/components/LeftItem.tsx